import { createLogger as reduxLogger } from 'redux-logger';

export default function createLogger() {
  return reduxLogger({
    collapsed: true,
    predicate: (getState, action) => !action.type.startsWith('@@redux-form'),
  });
}
